import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

let cachedAnimationData = null;
let animationLoadPromise = null;

async function loadLoadingAnimation() {
  if (cachedAnimationData) return cachedAnimationData;
  if (!animationLoadPromise) {
    const url = `${process.env.PUBLIC_URL || ""}/Assets/js/loading.json`;
    animationLoadPromise = fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`Failed to load ${url} (${r.status})`);
        return r.json();
      })
      .then((json) => {
        cachedAnimationData = json;
        return json;
      });
  }
  return animationLoadPromise;
}

loadLoadingAnimation().catch(() => {});

export default function LoadingOverlay({ open, variant = "content", size = 120 }) {
  const [animationData, setAnimationData] = useState(cachedAnimationData);

  useEffect(() => {
    if (!open) return;
    if (animationData) return;

    let cancelled = false;
    loadLoadingAnimation()
      .then((data) => {
        if (!cancelled) setAnimationData(data);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [open, animationData]);

  if (!open) return null;

  const isContent = variant === "content";

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: isContent ? "absolute" : "fixed",
        inset: 0,
        /* No dim/blur background (matches your reference: loader inside container) */
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
      }}
    >
      {animationData ? (
        <div style={{ width: size, height: size }}>
          <Lottie animationData={animationData} loop autoplay />
        </div>
      ) : null}
    </div>
  );
}

